import React from 'react';
import Image from './Image';
import Price from './Price';
import GenericButton from './GenericButton';
import { useSelector } from 'react-redux';
import { isMobile } from 'react-device-detect';

/**
 * @param props.id
 * @param props.title
 * @param props.description
 * @param props.imageFileName
 * @param props.imageAlt
 * @param props.price
 * @param props.discount
 * @param props.isInsuranceLoading
 * @param props.isInsuranceEnabled
 * @param props.isSelected
 * @param props.isDisabled
 * @param props.isWarranty
 * @param props.isLearnMore
 * @param props.handleAddButton
 * @param props.handleChange
 * @param props.tabIndex
 */
const StepRadioButton = props => {
    const labels = useSelector(state => state.main.labels);
    const baseURLs = useSelector(state => state.main.baseURLs);
    const blueDisclaimer = useSelector(state => state.main.blueDisclaimer);
    const isLensGaming = useSelector(state => state.main.isLensGaming);
    const isGVP = useSelector(state => state.main.isGVP);

    //Handles step add button tabIndex
    const addButtonTabIndex = props.tabIndex ? (parseInt(props.tabIndex) + 1).toString() : '0';

    const showColor = () => {
        let selector =
            (isMobile ? '.learn-more-mobile ' : '.learn-more-desktop ') +
            '.step-radio-button.selected';
        let element = document.querySelector(selector);
        element.classList.toggle('is-flipped');
    };

    const renderShowColor = () => {
        return Object.values(props.visibleColorCategories).map(colorCategoryPackage => {
            if (props.colorLearnMoreOptions[colorCategoryPackage]) {
                const lensColorRow = Object.values(
                    props.colorLearnMoreOptions[colorCategoryPackage]
                ).map(color => {
                    return (
                        <>
                            <Image
                                imageClass={
                                    color.imageFileName2
                                        ? 'show-color-lens'
                                        : 'show-color-lens circle-color-button'
                                }
                                url={baseURLs.projectImage}
                                fileName={
                                    color.imageFileName2
                                        ? color.imageFileName2
                                        : color.imageFileName1
                                }
                            />
                        </>
                    );
                });
                return (
                    <div className="color-row">
                        {/* Prendo solo la prima parte del nome, per ora */}
                        <div className="title-row">{colorCategoryPackage.split(' ')[0]}</div>
                        <div className="container-row">{lensColorRow}</div>
                    </div>
                );
            }
        });
    };

    return (
        <div className="step-radio-button-container">
            <button
                id={props.id}
                className={
                    'step-radio-button' +
                    (props.isSelected ? ' selected' : '') +
                    (props.isInsuranceLoading ? ' loading' : '') +
                    (props.isInsuranceLoading ? ' step-disabled' : '') +
                    ((props.isIncluded || props.isAlreadyIncluded) && !props.isLearnMore
                        ? ' included-selection'
                        : '') +
                    (props.group === 'colorCategory' && isMobile ? ' padding-bottom-30' : '')
                }
                onClick={!props.isDisabled ? props.handleChange : null}
                ref={props.firstLearnMoreTreatment}
                data-analytics_available_call={
                    props.isLearnMore ? null : props.isDisabled || props.isAlreadyIncluded ? 0 : 1
                }
                data-element-id={props.isLearnMore ? 'X_X_LensPanel_Treatments-LearnMoreSee' : null}
                data-description={props.isLearnMore ? props.title : null}
                tabIndex={props.tabIndex ? props.tabIndex : props.isDisabled ? '-1' : '0'}
                disabled={props.isDisabled || props.isInsuranceLoading}
            >
                <div className="step-radio-button-content">
                    <Image
                        key={props.id}
                        imageClass="step-radio-button-image"
                        url={baseURLs.projectImage}
                        fileName={props.imageFileName}
                        alt={props.imageAlt}
                    />
                    <div className="step-radio-button-inner-content">
                        <div className="step-radio-button-title">
                            {props.isWarranty ? labels.steps.warranty.oneYear : props.title}
                        </div>
                        <div className="step-radio-button-price">
                            {!props.isIncluded && !props.isAlreadyIncluded && (
                                <Price
                                    value={props.price}
                                    discount={props.discount}
                                    isInsuranceLoading={props.isInsuranceLoading}
                                    isInsuranceEnabled={props.isInsuranceEnabled}
                                    isGVPPrice={
                                        isGVP && !props.isInsuranceEnabled && !props.isWarranty
                                    }
                                    isTreatmentPrice={!props.isWarranty}
                                    isWarrantyPrice={props.isWarranty}
                                    showInsurancePrice={props.isSelected || props.isWarranty}
                                />
                            )}
                            {(props.isIncluded || props.isAlreadyIncluded) && (
                                <>
                                    <span className="included-treatment">
                                        {labels.steps.treatments.alreadyIncluded}
                                    </span>
                                </>
                            )}
                            {!props.isIncluded &&
                                !props.isAlreadyIncluded &&
                                props.isInsuranceEnabled &&
                                !props.isInsuranceLoading &&
                                !props.isSelected &&
                                !props.isWarranty && (
                                    <span className="treatment-step-label">
                                        {labels.steps.treatments.selectTreatmentInsurance}
                                    </span>
                                )}
                        </div>
                        {props.isLearnMore && props.isSelected && (
                            <div
                                className="step-radio-button-desc-learn-more"
                                dangerouslySetInnerHTML={{ __html: props.description }}
                            ></div>
                        )}
                    </div>
                </div>

                <div className="step-radio-button-content-mobile">
                    <div className="step-radio-button-header">
                        <Image
                            key={props.id}
                            imageClass="step-radio-button-image"
                            url={baseURLs.projectImage}
                            fileName={props.imageFileName}
                            alt={props.imageAlt}
                        />
                        <div className="step-radio-button-inner-content">
                            <div className="step-radio-button-title">
                                {props.isWarranty ? labels.steps.warranty.oneYear : props.title}
                            </div>
                            <div className="step-radio-button-price">
                                {!props.isIncluded && !props.isAlreadyIncluded && (
                                    <Price
                                        value={props.price}
                                        discount={props.discount}
                                        isInsuranceLoading={props.isInsuranceLoading}
                                        isInsuranceEnabled={props.isInsuranceEnabled}
                                        isGVPPrice={
                                            isGVP && !props.isInsuranceEnabled && !props.isWarranty
                                        }
                                        isTreatmentPrice={!props.isWarranty}
                                        isWarrantyPrice={props.isWarranty}
                                        showInsurancePrice={props.isSelected || props.isWarranty}
                                    />
                                )}
                                {props.isIncluded && (
                                    <>
                                        <span className="included-treatment">
                                            {labels.steps.treatments.alreadyIncluded}
                                        </span>
                                    </>
                                )}
                                {!props.isIncluded &&
                                    props.isInsuranceEnabled &&
                                    !props.isInsuranceLoading &&
                                    !props.isSelected &&
                                    !props.isWarranty && (
                                        <span className="treatment-step-label">
                                            {labels.steps.treatments.selectTreatmentInsurance}
                                        </span>
                                    )}
                            </div>
                        </div>
                    </div>
                    {props.isLearnMore && (
                        <div
                            className="step-radio-button-desc-learn-more"
                            dangerouslySetInnerHTML={{ __html: props.description }}
                        ></div>
                    )}
                </div>

                {(!props.isLearnMore && !isGVP) || props.isWarranty ? (
                    <div
                        className={'step-radio-button-icon' + (props.isIncluded ? ' hidden' : '')}
                    ></div>
                ) : (
                    props.isSelected && (
                        <>
                            <div
                                className={
                                    'container-bottom' +
                                    (props.group === 'colorCategory' && isMobile
                                        ? ' margin-top-40'
                                        : '')
                                }
                            >
                                {props.group === 'blueLight' && !isLensGaming ? (
                                    <div
                                        className="blue-disclaimer-mobile"
                                        dangerouslySetInnerHTML={{ __html: blueDisclaimer }}
                                    ></div>
                                ) : null}
                                {!(props.isIncluded || props.isAlreadyIncluded || isGVP) && (
                                    <GenericButton
                                        tabIndex={addButtonTabIndex}
                                        className="border-button add-button"
                                        handleClick={props.handleAddButton}
                                        title="Add"
                                        dataDescription={props.title}
                                        dataElementId="X_X_LensPanel_Treatment-Choose"
                                        noArrow
                                    >
                                        {labels.add}
                                    </GenericButton>
                                )}
                            </div>
                        </>
                    )
                )}
                {props.isLearnMore && props.group === 'colorCategory' ? (
                    <>
                        {props.group === 'colorCategory' ? (
                            <button className="step-radio-button-show-color" onClick={showColor}>
                                {labels.showColor}
                            </button>
                        ) : null}
                        <div className="card__face card__face--back">
                            <div className="container">{renderShowColor()}</div>
                            <div className="container-learn-more-hide">
                                <button
                                    className="step-radio-button-hide-color"
                                    onClick={showColor}
                                >
                                    {labels.hideColor}
                                </button>
                            </div>
                        </div>
                    </>
                ) : null}
            </button>
        </div>
    );
};

export default StepRadioButton;
